export default __webpack_public_path__ + "static/media/plus.7688215f.svg";